import React from "react";

// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
import CircularProgress from '@material-ui/core/CircularProgress';

// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";

import userProfileStyles from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.jsx";

import axios from 'axios';
import { API_ROOT } from 'api-config';
import { getApiHeaders } from '../../assets/helpers/apiHelper.jsx';

class AcceptInvitation extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;

    this.handleAcceptInvitation = this.handleAcceptInvitation.bind(this);
    this.state = {
      userId: sessionStorage.getItem('userId'),
      validCode: false,
      invitingUser: '',
      invitingUserId: '',
      invitationTo: '',
      invitationMessage: '',
      buttonDisabled: false,
      invitationStatus: '',
      invitationStatusIndicator: ''
    };
  }

  componentDidMount(){
    this._isMounted = true;
    this.getInvitationDetails()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getInvitationDetails() {
    axios.get(`${API_ROOT}/invitationCode/?invitationCode=` + this.props.invitationCode + `&providerId=patient`,
      {headers: getApiHeaders()}).then(res => this.setInvitationDetails({responseMessage: res.data}));

  }

  setInvitationDetails(res) {
    if (this._isMounted) {
      var invitationMessage = ''
      if (res.responseMessage.validCode) {
        invitationMessage = "You have received an invitation to join a group from " + res.responseMessage.invitingUser + ". " +
          "This invitation was sent to " + res.responseMessage.invitationTo + ". If you accept this " +
          "invitation, " + res.responseMessage.invitingUser + " will be able to view and modify all parts of your account."
      } else {
        invitationMessage = "The invitation is invalid or has already been used."
      }

      this.setState({
        validCode: res.responseMessage.validCode,
        invitingUser: res.responseMessage.invitingUser,
        invitingUserId: res.responseMessage.invitingUserId,
        invitationTo: res.responseMessage.invitationTo,
        invitationMessage: invitationMessage
      })
    }
  }

  handleAcceptInvitation = (e) => {
    e.preventDefault();
    const statusIndicator = <CircularProgress size={20}/>
    this.setState({
      submitButtonText: 'accepting',
      invitationStatus: 'accepting...',
      buttonDisabled: true,
      invitationStatusIndicator: statusIndicator
    })
    const invitationData = {
      userId: this.state.userId,
      providerId: this.props.invitationProviderId,
      invitationCode: this.props.invitationCode,
      invitationAction: 'accept'
    }
    axios.post(`${API_ROOT}/invitationResponse/`, invitationData, { headers: getApiHeaders() })
      .then(res => this.handleAcceptInvitationResponse(res));
  }

  handleAcceptInvitationResponse(res) {
    if (this._isMounted) {
      var invitationStatus
      var buttonDisabled
      if (res.data.message === 'success') {
        invitationStatus = 'You have successfully accepted the invitation. Please close this window to proceed.'
        buttonDisabled = true
        sessionStorage.setItem('invitationCode', '');
      } else {
        if (res.data.error) {
          invitationStatus = res.data.error
        } else {
          invitationStatus = 'An unknown error occurred.'
        }
        buttonDisabled = false
      }
      this.setState({
        inputDisabled: false,
        submitButtonText: 'accept',
        invitationStatus: invitationStatus,
        invitationStatusIndicator: '',
        buttonDisabled: buttonDisabled
      })
    }
  }

  render() {
    return (
      <Card>
        <CardBody>
          <GridContainer>
            <GridItem xs={12} sm={12} md={12}>
              <span id={"invitationMessage"}>{this.state.invitationMessage}</span>
            </GridItem>
          </GridContainer>
          <GridItem xs={12} sm={12} md={12} style={this.state.validCode ? {} : { display: 'none' }}>
            <Button
              round
              onClick={this.handleAcceptInvitation}
              color="cirrusBlue"
              id="acceptInvitationButton"
              disabled={this.state.buttonDisabled}
            >
              accept
            </Button> <span id={"invitationStatus"}>{this.state.invitationStatusIndicator} {this.state.invitationStatus}</span>
          </GridItem>
        </CardBody>
      </Card>

    )

  }
}

export default withStyles(userProfileStyles)(AcceptInvitation);